import { render, staticRenderFns } from "./CRUDVigencia.vue?vue&type=template&id=55c75ef6&"
import script from "./CRUDVigencia.vue?vue&type=script&lang=js&"
export * from "./CRUDVigencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports